import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'dealer', pathMatch: 'full' },
  { path: 'dealer', loadChildren: () => import('./module/dealer/dealer.module').then(m => m.DealerModule) },
];
